<template>
    <div id="divider" :style="{}">

    </div>
</template>

<script>
    export default {
        name: "divider",
        props: {
            marginBottom: Number,
            marginStart: Number,
            marginEnd: Number,
            marginTop: Number,
            height: Number,
        }
    }
</script>

<style scoped>
    #divider {
        width: 100%;
        height: 0px;
        margin: 6px 0px 12px 0px;
        border-bottom: 1px solid #d8dae2;
    }
</style>